import { Component, inject, effect } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { SiteActions, SiteSelectors } from '@next/core-lib/site';
import { Store } from '@ngrx/store';

import { AppWizardModuleState } from './models/app-wizard.model';

@Component({
  selector: 'app-app-wizard',
  templateUrl: './app-wizard.component.html',
  styleUrls: ['./app-wizard.component.scss'],
  standalone: false,
})
export class AppWizardComponent {
  private readonly store = inject(Store<AppWizardModuleState>);
  private readonly route = inject(ActivatedRoute);

  pageTitle = toSignal(this.store.select(SiteSelectors.selectPageTitle));

  constructor() {
    effect(() => {
      const title = this.route.snapshot.data['pageTitle'];
      if (title) {
        this.store.dispatch(SiteActions.updatePageTitle({ pageTitle: title }));
      }
    });
  }
}
